'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var name = '@wh/modal-component';

// Actions
var CLOSE_MODAL = exports.CLOSE_MODAL = name + '/CLOSE_MODAL';
var OPEN_MODAL = exports.OPEN_MODAL = name + '/OPEN_MODAL';
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/modal-component/dist/main/constants.js
// module id = 177
// module chunks = 0